/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { withRouter } from 'react-router-dom';
import SelfCalenderVds from '../../../../components/Web/AppointmentScheduleRedesign/SelfCalenderVds';
// import AppointmentSchedule from '../../../components/AppointmentSchedule/index';
import * as appointmentScheduleActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import appointmentSchedule from '../../reducer';
import * as appointmentScheduleSelectors from '../../selectors/appointmentScheduleSelectors';
import * as loaderActions from '../../../../components/common/Loader/action';

const mapStateToProps = (state) => {
  const appointmentScheduleSelector = appointmentScheduleSelectors.selectData(state);
  const appointmentScheduleState = state.appointmentSchedule || {};
  const appointmentScheduleResponse = state.appointmentSchedule.appointmentScheduleResponse || {};
  const loader = state.loader || {};
  const updateSelfInstallationResponse = state.appointmentSchedule.updateSelfInstallationResponse || {};
  const cartDetails = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const currentView = state.currentView || {};
  return {
    appointmentScheduleSelector,
    appointmentScheduleState,
    appointmentScheduleResponse,
    loader,
    cartDetails,
    updateSelfInstallationResponse,
    currentView,
  };
};
// let AppointmentScheduleComponent = AppointmentScheduleSelf;
// debugger;
// const selfSetupData = (this.state.appointmentSchedule.appointmentScheduleResponse.output.installationType === 'Self Setup');
// if (selfSetupData) {
//   AppointmentScheduleComponent = AppointmentScheduleSelf;
// }
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...appointmentScheduleActions, loaderActions }, dispatch);
}
const withReducer = compose(
  injectReducer({ key: 'appointmentSchedule', reducer: appointmentSchedule }),
);

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const withSaga = injectSaga({ key: 'appointmentSchedule', saga });
export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect
  )(SelfCalenderVds),
);
